import {peekShopifyBootRoute} from './boot-route.js';
export function shopifyAuthNotice({verification=false}={}) {
  const path=peekShopifyBootRoute();
  if(!path)return '';
  const shop=new URLSearchParams(path.split('?')[1]||'').get('shop');
  if(!shop)return '';
  return `<aside class="shopify-auth-notice" aria-label="Continue Shopify setup"><strong>Continue your Shopify setup</strong><p>${shop}</p><p>${verification?'After verifying your email, return to this window and sign in.':'Sign in or create your Magnet account, then choose the workspace for your store.'} Shopify features require a paid plan.</p>${verification?'<a href="#/signin">I’ve verified my email — sign in</a>':''}<small>If this window expires, reopen the connection from the Shopify app.</small></aside>`;
}
